import axios from '@/utils/http';

export default params => {
  const formData = new FormData();
  formData.append('video', params.video);
  formData.append('nickname', params.nickname);
  return axios
    .post('/user/kyc_video', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
